import React from "react";
import {
  Button,
  Icon,
  Input,
  Form,
  Popconfirm,
  Table,
  notification
} from "antd";
import { DragDropContext, DragSource, DropTarget } from "react-dnd";

let dragingIndex = -1;

const EditableContext = React.createContext({});

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form} {...props} />
);

class EditableCell extends React.Component<{
  editingKey: number;
  record: any;
  onClickTitle: (key: any) => void;
  handleSave: (data: any, handleSave: boolean) => void;
  onDelete: () => void;
  addOption: () => void;
  dataIndex: string;
  index: string;
  editable: boolean;
  title: string;
}> {
  state = {
    editing: false
  };

  input: Input | null = null;
  form: any | null = null;

  componentDidMount() {
    // console.log({
    //   record: this.props.record,
    //   editingKey: this.props.editingKey
    // });
    if (
      this.props.record &&
      this.props.editingKey === this.props.record.order &&
      this.input
    ) {
      this.input.focus();
    }
  }
  componentDidUpdate() {
    if (
      this.props.record &&
      this.props.editingKey === this.props.record.order &&
      this.input
    ) {
      this.input.focus();
    }
  }

  handleFocus = e => {
    e.target.select();
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing && this.input) {
        this.input.focus();
      }
    });
  };

  setEditKey = key => () => {
    const { onClickTitle } = this.props;
    onClickTitle(key);
  };

  save = (onEnter = false) => e => {
    e.preventDefault();
    const {
      record,
      handleSave,
      onClickTitle,
      dataIndex,
      onDelete
    } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      // this.toggleEdit();
      // console.log({ values, dataIndex });
      onClickTitle(null);
      if (values[dataIndex] === "Type an option name" && onDelete) {
        // notification.warn({ message: "Please enter valid input!" });
        onDelete();
        return;
      }
      handleSave({ ...record, ...values }, onEnter);
    });
  };

  renderCell = form => {
    this.form = form;
    const { children, dataIndex, record, title, editingKey } = this.props;
    const { editing } = this.state;
    return editingKey === record.order ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`
            }
          ],
          initialValue: record[dataIndex]
        })(
          <Input
            ref={node => (this.input = node)}
            onPressEnter={this.save(true)}
            onBlur={this.save()}
            onFocus={this.handleFocus}
            placeholder="Type an option name"
          />
        )}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.setEditKey(record.order)}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

class BodyRow extends React.Component {
  render() {
    const { ...restProps } = this.props;
    const style = { ...restProps["style"], cursor: "move" };

    let className = restProps["className"];
    let isOver = restProps["isOver"];
    let connectDragSource = restProps["connectDragSource"];
    let connectDropTarget = restProps["connectDropTarget"];
    if (isOver) {
      if (restProps["index"] > dragingIndex) {
        className += " drop-over-downward";
      }
      if (restProps["index"] < dragingIndex) {
        className += " drop-over-upward";
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr {...this.props} className={className} style={style}>
          <EditableFormRow {...restProps} />
        </tr>
      )
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index
    };
  }
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  }
};

const DragableBodyRow = DropTarget("row", rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
}))(
  DragSource("row", rowSource, connect => ({
    connectDragSource: connect.dragSource()
  }))(BodyRow)
);

const EditableFormRow = Form.create()(EditableRow);
const Row = () => <EditableFormRow />;

export default {
  body: {
    row: DragableBodyRow,
    cell: EditableCell
  }
};
